import { useEffect } from "react";
import { ProjetoDimensionado } from "src/components/projetos/dimensionados";
import { EdicaoLayout } from "src/components/projetos/edicao/layouts/EdicaoLayout";
import { appStore } from "src/framework/store/AppStore";

const PAGE_TITLE = "Edição projeto dimensionado";

const ProjetoDimensionadoEdicaoPage = () => {
  useEffect(() => {
    appStore.setPageTitle(PAGE_TITLE);
    return () => {
      appStore.setPageTitle("");
    }
  }, [])

  return (
    <EdicaoLayout>
      <div className="container">
        <div className="row">
          <div className="X12">
            <ProjetoDimensionado />
          </div>
        </div>
      </div>
    </EdicaoLayout>
  );
};

export { ProjetoDimensionadoEdicaoPage };